import React, { useEffect, useRef, useState } from 'react'
import SortIcon from '../images/sort.svg'
import DownIcon from '../images/down.svg'
import { SORT_KEY_NAME, SORT_KEY_RECENT, SORT_ORDER_ASC, SORT_ORDER_DESC } from '../helpers/constants';
export default function SortBtn({setSort,sort}) {
    const [showPopup,setShowPopup] = useState(false)
    const ref = useRef(null);

    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setShowPopup(false);
        }
        else if(ref.current && ref.current.contains(event.target) && showPopup) setShowPopup(false)
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

  return (
    <div className='relative flex items-center ml-1'>
    <div className='flex justify-between rounded-md  transition-all bg-gray-100 md:bg-white hover:bg-gray-200 md:hover:bg-gray-100 px-2 py-1 md:px-2 md:py-2 cursor-pointer items-center' onClick={()=>setShowPopup(!showPopup)}>
        <img src={SortIcon} className='hidden md:block w-2 h-2'/>
        <p className='whitespace-nowrap hidden md:block text-[12px] md:text-xs text-gray-500 font-medium tracking-[-.1px] px-1'>{sort.sortKey === SORT_KEY_RECENT ? 'Recent' : sort.sortKey === SORT_KEY_NAME && sort.sortOrder === SORT_ORDER_ASC ? 'Name A-Z' : 'Name Z-A'}</p>
        <img src={SortIcon} className='md:hidden block w-4 h-4'/>
        <img src={DownIcon} className='hidden md:block w-2 h-2'/>
    </div>

    {showPopup ? <div ref={ref} className='absolute bg-white shadow-sm shadow-slate-200 border z-[99] border-gray-200 rounded-lg w-[120px] top-[100%] right-0 overflow-hidden'>
            <div className='flex px-4 py-3 w-full hover:bg-slate-50 cursor-pointer' onClick={()=>{setSort({sortKey:SORT_KEY_RECENT,sortOrder:SORT_ORDER_DESC});setShowPopup(false)}}>
                <p className='whitespace-nowrap text-[12px] font-medium  tracking-[-.15px] md:tracking-[-.25px] text-gray-700'>Recent</p>
            </div>
            <div className='flex px-4 py-3 w-full hover:bg-slate-50 cursor-pointer' onClick={()=>{setSort({sortKey:SORT_KEY_NAME,sortOrder:SORT_ORDER_ASC});setShowPopup(false)}}>
                <p className='whitespace-nowrap text-[12px] font-medium  tracking-[-.15px] md:tracking-[-.25px] text-gray-700'>Name A-Z</p>
            </div>
            <div className='flex px-4 py-3 w-full hover:bg-slate-50 cursor-pointer' onClick={()=>{setSort({sortKey:SORT_KEY_NAME,sortOrder:SORT_ORDER_DESC});setShowPopup(false)}}>
                <p className='whitespace-nowrap text-[12px] font-medium  tracking-[-.15px] md:tracking-[-.25px] text-gray-700'>Name Z-A</p>
            </div>
        </div> : null}
    </div>
  )
}
